import { createFileRoute } from '@tanstack/react-router';
import { CircularsInboxPage } from '@/features/circulars/CircularsInboxPage';

/* Le note di rilascio: le circolari con la versione, migrate dal changelog o scritte dal Master.
   Ci si arriva dal piede della pagina. `?open=` la apre subito: ci porta il campanello. */
export const Route = createFileRoute('/_app/circulars/release-notes')({
  component: ReleaseNotesRoute,
  validateSearch: (s: Record<string, unknown>): { open?: string } =>
    (typeof s.open === 'string' && s.open ? { open: s.open } : {}),
});

function ReleaseNotesRoute() {
  return <CircularsInboxPage kind="releases" openId={Route.useSearch().open ?? null} />;
}
